export default "__VITE_ASSET__Fg1qM6q9__"